/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Code_UnavailableInputs */

const en_us2_invite_code_unavailable = /** @type {(inputs: Invite_Code_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your invite could not be made just now. Try again.`)
};

const pt_br2_invite_code_unavailable = /** @type {(inputs: Invite_Code_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para criar seu convite agora. Tente de novo.`)
};

const pt_pt2_invite_code_unavailable = /** @type {(inputs: Invite_Code_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para criar seu convite agora. Tente de novo.`)
};

/** @type {(inputs: Invite_Code_UnavailableInputs) => LocalizedString} */
const es_419_invite_code_unavailable = en_us2_invite_code_unavailable;

/** @type {(inputs: Invite_Code_UnavailableInputs) => LocalizedString} */
const fr_fr2_invite_code_unavailable = en_us2_invite_code_unavailable;

/** @type {(inputs: Invite_Code_UnavailableInputs) => LocalizedString} */
const de_de2_invite_code_unavailable = en_us2_invite_code_unavailable;

/** @type {(inputs: Invite_Code_UnavailableInputs) => LocalizedString} */
const it_it2_invite_code_unavailable = en_us2_invite_code_unavailable;

/**
* | output |
* | --- |
* | "Your invite could not be made just now. Try again." |
*
* @param {Invite_Code_UnavailableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_code_unavailable = /** @type {((inputs?: Invite_Code_UnavailableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Code_UnavailableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_code_unavailable(inputs)
	if (locale === "es-419") return es_419_invite_code_unavailable(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_code_unavailable(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_code_unavailable(inputs)
	if (locale === "de-DE") return de_de2_invite_code_unavailable(inputs)
	if (locale === "it-IT") return it_it2_invite_code_unavailable(inputs)
	return en_us2_invite_code_unavailable(inputs)
});
export { invite_code_unavailable as "invite.code_unavailable" }